
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alerts/catalog/[[...params]]",
      function () {
        return require("private-next-pages/alerts/catalog/[[...params]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alerts/catalog/[[...params]]"])
      });
    }
  